// packages/world-model/src/traits/cuttable/index.ts

export * from './cuttableTrait.js';
